import { render, staticRenderFns } from "./ModalBackdrop.vue?vue&type=template&id=3b64bc16&scoped=true&"
import script from "./ModalBackdrop.vue?vue&type=script&lang=js&"
export * from "./ModalBackdrop.vue?vue&type=script&lang=js&"
import style0 from "./ModalBackdrop.vue?vue&type=style&index=0&id=3b64bc16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64bc16",
  null
  
)

export default component.exports